import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function VisionAndMission() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>Vision</h2>
                        <p>
                          To make IDPL a vibrant drug manufacturing company.
                        </p>
                        <h2>Mission</h2>
                        <p>
                          To manufacture and supply essential medicines and
                          generic drugs for supply to Central/State Government
                          organisations/ Trade at reasonable & affordable
                          prices.
                          <br /> To meet emergency need of the country for
                          supply of medicines during natural calamities &
                          emergent situations.
                        </p>

                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
